import React from 'react';

import { IconTile } from '@atlaskit/icon';
import type { GlyphProps } from '@atlaskit/icon/types';
import AddIcon from '@atlaskit/icon/core/add';

export const Space16Icon = (props: GlyphProps) => {
	const label = props.label || '';
	return (
		<IconTile
			key="spaceIcon"
			label={label}
			appearance="blue"
			shape="square"
			size="16"
			icon={AddIcon}
			testId={props.testId}
		/>
	);
};
